import { useState, React } from "react";

import DownloadButton from "../buttons/DownloadButton"; // Import the DownloadButton component
// import FilterModalTelegram from '../popups/FilterModalTelegram';
import FilterModalTwitter from "../popups/FilterModalTwitter";
import { FilterIcon } from "../icons";
function TwitterDashboard() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const csvFileUrl = `${process.env.PUBLIC_URL}/twitter_v1.csv`;

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div className="dashboard-actions">
      <button type="button" className="btn btn-secondary" onClick={toggleModal}>
        <FilterIcon />
        Filter By
      </button>
      <DownloadButton label="Download Twitter Data" fileUrl={csvFileUrl} />
      {isModalOpen && <FilterModalTwitter onToggle={toggleModal} />}
    </div>
  );
}

export default TwitterDashboard;
